module.exports = function (pageTitle) {
    return {
        event: 'pageUpdate',
        eventContext: {
            pageTitle
        }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/pagemetadata/page-title-mapper.js
 **/